import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'level'

  static get fields () {
    return {
      id: new UUID(),
      access: new STRING(),
      description: new STRING(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME()
    }
  }
}
